import React from 'react';
import styled from 'styled-components';
import { IInputHeader } from './types';

import theme from '../../../../styles/userflow';

const InputHeader: React.FC<IInputHeader> = props => {
  const { className, text, prependIcon, isMobile = false } = props;

  const hasContent = Boolean(text) || Boolean(prependIcon);

  if (!hasContent) {
    return null;
  }

  return (
    <StyledInputHeader className={className}>
      {text ? (
        <StyledHeaderWrapper>
          <StyledHeader>{text}</StyledHeader>
        </StyledHeaderWrapper>
      ) : null}
      {prependIcon ? (
        <StyledPrependIconContainer isMobile={isMobile} isEmpty={false}>
          {prependIcon}
        </StyledPrependIconContainer>
      ) : null}
    </StyledInputHeader>
  );
};

const ICON_HEIGHT = 14;
const ICON_WIDTH = 14;
const ICON_PADDING = 10;

const StyledInputHeader = styled.label`
  margin-bottom: 4px;
  display: flex;
  position: relative;
`;

const StyledPrependIconContainer = styled.div<{
  isEmpty?: boolean;
  isMobile: boolean;
}>`
  margin-top: ${({ isMobile }) => (isMobile ? 3 : 5)}px;
  margin-left: ${ICON_PADDING}px;
  svg:first-child {
    position: relative;
    height: ${ICON_HEIGHT}px;
    width: ${ICON_WIDTH}px;
    stroke-width: 1;
    ${({ isEmpty }) => `
      stroke: ${isEmpty ? theme.colors.greyLight : theme.colors.blackLight}
    `};
  }
`;

const StyledHeader = styled.div`
  font-size: 14px;
  line-height: 16px;
  align-items: center;

  color: ${theme.colors.blackLight};
`;

const StyledHeaderWrapper = styled.div`
  margin: 4px 0;
  display: flex;
  div + div {
    margin-left: 4px;
  }
`;

export default InputHeader;
